<template>
    <a-form ref='form' :style="{'marginBottom':'10px','display':'flex'}">
        <a-form-item label="关键字">
          <a-input type="text" style="width:220px" v-model:value="keyword" :placeholder="tableKey==1?'请输入红包金额/红包类型':'请输入优惠券名称/优惠类型'"></a-input>
        </a-form-item>
        <a-form-item class="m-l-20">
          <a-button type="primary" htmlType='submit' @click="getList">搜索</a-button>
        </a-form-item>
      </a-form>

    <a-table :columns="columns" :loading="Loading" :data-source="data" rowKey="id" :pagination="pagination" @change="changePagination">
      <template v-slot:action="{ record }">
          <a-button type='primary' style="width:75px" :ghost="!record.checkbox" @click="selectItem(record)">{{record.checkbox?'已选择':'选择'}}</a-button>
      </template>
    </a-table>
</template>
<script>
import {onMounted, reactive, ref,toRefs} from 'vue';
import {getBonusList} from '@/api/red.js';
import {getCouponList} from '@/api/assets.js'
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';
const column = [
    {
      title:'红包类型',
      dataIndex: "bonus_type_text"
    },
    {
        title:'红包金额',
        dataIndex: "amount"
    },
    {
        title:'红包说明',
        dataIndex: "description"
    },
    {
        title:'使用说明',
        dataIndex: "use_description"
    },
    {
          title:'操作',
          key: "action",
          width:100,
          fixed: 'right',
          slots: { customRender: "action" },
    }
]
const column2 = [
    {
      title:'名称',
      dataIndex: "name"
    },
    {
        title:'优惠',
        dataIndex: "amount_text"
    },
    {
        title:'券类型',
        dataIndex: "coupon_type"
    },
    {
        title:'有效期',
        dataIndex: "valid_period_time"
    },
    {
          title:'操作',
          key: "action",
          width:100,
          fixed: 'right',
          slots: { customRender: "action" },
    }
]
export default {
    props:{
        tableKey:{
            type:Number,
            default:1
        },
        tableId:{
            type:String,
            default:''
        }
    },
    setup(props,{emit}){
      
       const state = reactive({
           columns:[],
           data:[],
           keyword:'',
           pagination:{
             total:0,
             current:1,
             pageSize:5
           },
           Loading:false
       })

      const methods = {
          async getList(type){
              state.Loading = true;
              let res;
              if(props.tableKey==1){
                state.columns = column;
              res = await getBonusList({limit:state.pagination.pageSize,page:state.pagination.current,keyword:state.keyword,birthday:1}).then(res=>res.data);

              }else{
                state.columns = column2;
                res = await getCouponList({limit:state.pagination.pageSize,page:state.pagination.current,keyword:state.keyword}).then(res=>res.data)
              }
               
              if(iscode(res)){
                state.data = res.data.data || [];
                state.pagination.total=res.data.total,
                state.data.forEach(item=>{
                    if(item.id==props.tableId){
                        item.checkbox = true;
                    }
                })
                state.Loading = false;
              }else{
                  state.Loading = false;
                  message.error(res.msg)
              }

            

             
          },
          selectItem(record){
              record.checkbox = !record.checkbox;
              emit('change',record)
          },
          changePagination(e){
              state.pagination.current = e.current;
              methods.getList()
          }
      }

      onMounted(()=>{
          methods.getList()
      })
      return{
          ...methods,
          ...toRefs(state)
      }
    }
}
</script>